<script lang="ts">
  import { page } from "$app/stores";

  import { findDishNameMenu } from "$lib/db/menu.js";
  import { addDishToCart, cart, getCartSize } from "$lib/stores/cart";

  import OptionDisplay from "$lib/components/customer/OptionDisplay.svelte";

  export let data;
  const menu = data.menu;

  let added = false;

  let dish: Dish = findDishNameMenu(data.dishName, menu);
  let selectedOptions = new Array(dish.options.length).fill(false);

  let sortedOptions: any = {};

  let otherOptions: Option[] = [];

  for (let i = 0; i < dish.options.length; i++) {
    let category = dish.options[i].optionCategory;

    if (typeof category === "undefined") {
      otherOptions.push(dish.options[i]);
      otherOptions = otherOptions;
    } else {
      category = category.trim();
      if (!sortedOptions[category]) {
        sortedOptions[category] = [dish.options[i]];
      } else {
        sortedOptions[category].push(dish.options[i]);
      }
    }
  }

  function addToCart() {
    // set the selected options as an array of booleans
    dish.selectedOptions = [...selectedOptions];

    addDishToCart($cart, dish);

    $cart = $cart;
    // console.log($cart);

    dish = findDishNameMenu(data.dishName, menu);
    added = true;
  }
</script>

<div class="htmlBody">
  <div class="image_container">
    {#await dish.imageURL then image}
      <img src={image} alt="" />
    {/await}
  </div>

  <div class="details">
    <span class="name_style">{dish.name}</span>
    <div data-testid={"dish_price " + dish.name} class="dish_price">
      ${dish.price.toFixed(2)}
    </div>
    <span class="dish_description">{dish.description}</span>
  </div>

  <div class="options">
    {#if dish.options.length > 0}
      <div class="name_style">Options:</div>
      {#each Object.keys(sortedOptions).sort( (a, b) => a.localeCompare(b) ) as optionCat}
        <div data-testid="option cat {optionCat}">
          {optionCat}

          {#each sortedOptions[optionCat] as option}
            <OptionDisplay {option} {selectedOptions} {dish} />
          {/each}
        </div>
      {/each}

      {#if otherOptions.length > 0}
        Others
        {#each otherOptions as option}
          <OptionDisplay {option} {selectedOptions} {dish} />
        {/each}
      {/if}
    {/if}
  </div>

  <div class="alert-msg" id="alert-msg-added" style:opacity={added ? "1" : "0"}>
    Added! <br />
    <span data-testid="cart_count_options">{getCartSize($cart)}</span>
    items in the cart
  </div>

  <div class="footerOut">
    <div class="itemText">
      <span data-testid="cart_count">{getCartSize($cart)}</span>
    </div>

    <a
      data-testid="cart_button"
      class="shoppingCart"
      href={`/shop/${$page.params.shopID}/customer/checkoutCart`}
      style="text-decoration: none; color: white;"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        fill="currentColor"
        class="bi bi-cart2"
        viewBox="0 0 16 16"
      >
        <path
          d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
        />
      </svg>
    </a>
  </div>

  <button
    data-testid="add_to_cart"
    class="addToCartBut"
    on:click={() => addToCart()}>Add To Cart</button
  >
  <a
    data-testid="options_back"
    href={`/shop/${$page.params.shopID}/customer`}
    class="backBut"
    style="color: var(--primary-colour);text-decoration: none;">Back</a
  >
</div>

<style>
  .image_container {
    width: 280px;
    height: 280px;

    margin: 20px auto;
  }

  .image_container img {
    object-fit: cover;
  }

  .image_container img {
    width: inherit;
    height: inherit;
    margin: 0px auto;
  }

  .addToCartBut {
    display: block;

    padding: 12px 20px;
    margin: 10px auto;

    background-color: var(--primary-colour);
    border: none;
    color: white;

    width: 100%;

    text-align: center;
    text-decoration: none;
    font-size: 16px;
    border-radius: 10px;
  }

  .addToCartBut:active {
    opacity: 50%;
  }

  .backBut {
    display: block;

    margin: 10px auto;
    padding: 12px 20px;
    width: inherit;

    margin-bottom: 90px;

    border: 3px solid var(--primary-colour);

    text-align: center;
    font-size: 16px;
    border-radius: 10px;
  }

  .backBut:active {
    opacity: 50%;
  }

  .name_style {
    margin: 10px 0px;
    font-size: larger;
    font-weight: 800;
  }

  .dish_price {
    display: block;
    float: right;

    position: relative;
    top: 3px;
    right: 5px;
  }

  .dish_description {
    display: block;
    margin: 10px auto;
    padding-bottom: 30px;
    border-bottom: 1px solid grey;
  }

  .options {
    margin: 30px auto;
    padding-bottom: 20px;
    border-bottom: 1px solid grey;
  }

  .alert-msg {
    margin: 20px auto;
    padding: 10px 10px;

    border: 1px solid green;
    border-left: 5px solid green;
    border-radius: 8px;

    transition: 1s;
    opacity: 0;
  }

  .footerOut {
    position: fixed;
    bottom: 20px;
  }

  .shoppingCart {
    display: block;

    border-radius: 20px;
    background-color: var(--primary-colour);

    padding: 20px;
    height: 35px;
    width: 35px;

    box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.5);
  }
  .shoppingCart:active {
    opacity: 0.8;
  }
  .itemText {
    position: relative;

    top: 20px;
    left: -5px;
    z-index: 20;

    height: 40px;
    width: 40px;
    border-radius: 50px;

    text-align: center;
    font-weight: 600;
    color: white;

    background-color: var(--accent-colour);
    box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.5);
  }

  .itemText span {
    display: block;
    color: black;
    padding: 11px;
  }
</style>
